import { useCallback } from "react";
import { Link } from "react-router-dom";
import { FiThumbsUp, FiThumbsDown, FiX } from "react-icons/fi";
import { IconButton, Tooltip } from "@datapay-by-datacom/design-system";
import { useThreadExitFeedback } from "../hooks/useThreadExitFeedback";
import s from "./ThreadExitFeedbackPrompt.module.css";

export function ThreadExitFeedbackPrompt() {
  const { promptData, submitFeedback, dismiss, pauseAutoDismiss, resumeAutoDismiss } =
    useThreadExitFeedback();

  const handleMouseEnter = useCallback(() => {
    pauseAutoDismiss();
  }, [pauseAutoDismiss]);

  const handleMouseLeave = useCallback(() => {
    resumeAutoDismiss();
  }, [resumeAutoDismiss]);

  const visible = promptData !== null;

  return (
    <div
      className={`${s.wrapper} ${visible ? s.wrapperVisible : ""}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {promptData && (
        <div className={s.banner}>
          <span className={s.label}>
            Was the response for{" "}
            <Link to={`/${promptData.threadId}`} className={s.threadTitle}>
              {promptData.threadTitle}
            </Link>{" "}
            helpful?
          </span>
          <div className={s.actions}>
            <Tooltip text="Helpful">
              <IconButton
                variant="ghost"
                size="1"
                className={s.feedbackButton}
                onPress={() => submitFeedback(1)}
              >
                <FiThumbsUp size={18} />
              </IconButton>
            </Tooltip>
            <Tooltip text="Not helpful">
              <IconButton
                variant="ghost"
                size="1"
                className={s.feedbackButton}
                onPress={() => submitFeedback(-1)}
              >
                <FiThumbsDown size={18} />
              </IconButton>
            </Tooltip>
            <Tooltip text="Dismiss">
              <IconButton
                variant="ghost"
                size="1"
                className={s.dismissButton}
                onPress={dismiss}
              >
                <FiX size={14} />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      )}
    </div>
  );
}
